// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3Nhb7","title":"ClientCherryInfo_title__3qNnN","itemText":"ClientCherryInfo_itemText__2A6nh"};